import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/calculator';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: props.model,
            showIframe: false,
            error: null,
            inputValue: props.model.creditSum,
            rangePercent: 0,
            rangePercent1: 0,
            rangePercent2: 0,
            valueWith: 44,
            valueWidth2: 0
        };

        this.hiddenValue = React.createRef();
        this.hiddenValue2 = React.createRef();
        this.crefs = {};

        return this;
    }

    toggleIframe = () => this.setState(state => ({showIframe: !state.showIframe}));

    handleChangeInsurance = () => {
        const model = this.state.model;

        model.switchInsurance();
        this.setState({model});
    };

    toggleMode = e => {
        let mode,
            target = e.target;

        while (!mode) {
            mode = target.name;
            target = target.parentElement;
        }

        const event = new CustomEvent('switchCalcMode', {
            detail: {
                mode
            }
        });

        document.dispatchEvent(event);
    };

    componentWillMount() {
        const model = this.state.model;
        model.calculateIndicators();
        this.setState({model});
    }

    componentDidUpdate(prevProps) {
        const keys = ['mode', 'currentName', 'tab'];

        const hasChanged = keys.some(key => prevProps[key] !== this.props[key]);

        if (hasChanged) {
            this.getValueWith();
        }
    }

    componentDidMount() {
        this.getValueWith();
    }

    componentWillReceiveProps(props) {
        if (this.props.type !== props.type) {
            const model = this.state.model;

            model.switchType(props.type);
            model.resetIndicators();
            model.calculateIndicators();
            this.setState({model});
        }
    }

    handleChange = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let {value} = e.target;
        value = this.restrictInput(value);
        let rangePercent = this.state.rangePercent,
            error = this.state.error;
        if (props?.name === 'selectedType') {
            model.changeField('creditSum', model.getMinSumEdge());
            model.changeField('loanTerm', 0);
            rangePercent = 0;
        }
        if (name === 'creditSum') {
            rangePercent = this.getRange(
                e.target.value,
                model.getMinSumEdge(),
                model.getMaxSumEdge()
            );
            error = this.getError(value);
        }
        model.changeField(name || props.name, value);
        this.setState({model: model, rangePercent: rangePercent, error}, () => this.getValueWith());
    };

    handleChange1 = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let {value} = e.target;
        value = this.restrictInput(value);
        let rangePercent1 = this.getRange(e.target.value, e.target.min, e.target.max);
        let rangePercent2 = this.getRange(e.target.value, e.target.min, e.target.max);
        let rangePercent = this.state.rangePercent;
        let error = this.state.error;
        if (props?.name === 'selectedType') {
            model.changeField('creditSum', model.getMinSumEdge());
            model.changeField('loanTerm', 0);
            rangePercent1 = 0;
        }
        if (name === 'creditSum') {
            rangePercent = rangePercent2;
            error = this.getError(value);
        }
        if (name === 'loanTerm' && !e.target.min) {
            rangePercent1 = this.getRange(
                e.target.value,
                model.getMinTermEdge(),
                model.getMaxTermEdge()
            );
            error = this.getError(value);
        }
        if (e.target.dataset.min && e.target.dataset.max) {
            rangePercent1 = this.getRange(
                e.target.value,
                e.target.dataset.min,
                e.target.dataset.max
            );
            rangePercent2 = this.getRange(
                e.target.value,
                e.target.dataset.min,
                e.target.dataset.max
            );
        }
        model.changeField(name || props.name, value);
        this.setState(
            {
                model: model,
                rangePercent1,
                rangePercent2,
                rangePercent,
                error
            },
            () => this.getValueWith()
        );
    };

    handleChange2 = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let {value} = e.target;
        value = this.restrictInput(value);
        let rangePercent2 = this.getRange(e.target.value, e.target.min, e.target.max);
        let rangePercent1 = this.getRange(e.target.value, e.target.min, e.target.max);
        if (props?.name === 'selectedType') {
            model.changeField('creditSum', model.getMinSumEdge());
            model.changeField('loanTerm', 0);
            rangePercent1 = 0;
            rangePercent2 = 0;
        }
        if (e.target.dataset.min && e.target.dataset.max) {
            rangePercent1 = this.getRange(
                e.target.value,
                e.target.dataset.min,
                e.target.dataset.max
            );
            rangePercent2 = this.getRange(
                e.target.value,
                e.target.dataset.min,
                e.target.dataset.max
            );
        }
        model.changeField(name || props.name, value);
        if (e.target.value === this.state.model.shopCreditTerm) {
            this.setState({
                model: model,
                rangePercent1: rangePercent1,
                rangePercent2: rangePercent2
            });
        }
        this.setState({model: model, rangePercent2: rangePercent2});
    };

    handleChange3 = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let {value} = e.target;
        value = this.restrictInput(value);
        let rangePercent1 = this.getRange(e.target.value, e.target.min, e.target.max);
        let rangePercent = this.state.rangePercent;
        const error = this.state.error;
        if (props?.name === 'selectedType') {
            model.changeField('creditSum', model.getMinSumEdge());
            model.changeField('loanTerm', 0);
            rangePercent = 0;
        }
        if (e.target.dataset.min && e.target.dataset.max) {
            rangePercent1 = this.getRange(
                e.target.value,
                e.target.dataset.min,
                e.target.dataset.max
            );
        }
        model.changeField(name || props.name, value);
        this.setState(
            {
                model: model,
                rangePercent1,
                error
            },
            () => this.getValueWith()
        );
    };

    handleChange4 = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let {value} = e.target;
        value = this.restrictInput(value);
        let rangePercent1 = this.getRange(e.target.value, e.target.min, e.target.max);
        const rangePercent2 = this.getRange(e.target.value, e.target.min, e.target.max);
        let rangePercent = this.state.rangePercent;
        let error = this.state.error;
        if (props?.name === 'selectedType') {
            model.changeField('creditSum', model.getMinSumEdge());
            model.changeField('loanTerm', 0);
            rangePercent1 = 0;
        }
        if (name === 'creditSum') {
            rangePercent = rangePercent2;
            error = this.getError(value);
        }
        model.changeField(name || props.name, value);
        this.setState(
            {
                model: model,
                rangePercent,
                error
            },
            () => this.getValueWith()
        );
    };

    handleChangeInput = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let max = model.getMaxSumEdge(),
            {value} = e.target;
        value = this.restrictInput(value);
        const target = e.target;
        const targetSelectionEnd = target.selectionEnd;
        const rangePercent = this.getRange(value, e.target.min, e.target.max);
        const error = name === 'creditSum' ? this.getError(value) : this.state.error;
        if (name === 'term') {
            max = model.getTerms()[1];
        }
        if ((isFinite(+value) && +value === parseInt(value, 10)) || value === '') {
            if (value > max) {
                e.target.value = max;
                model.changeField(name || props.name, max);
            } else {
                model.changeField(name || props.name, value);
            }
            this.setState(
                {
                    model,
                    rangePercent: rangePercent,
                    error
                },
                () => {
                    this.getValueWith();
                    this.setCaret(target, targetSelectionEnd);
                }
            );
        }
    };

    setCaret = (target, targetSelectionEnd) => {
        if (target.value === '' || target.value === '0') {
            target.setSelectionRange(1, 1);
        } else {
            let newPosition = targetSelectionEnd + 1;
            if (newPosition > target.value.length) {
                newPosition = target.value.length;
            }
            target.setSelectionRange(newPosition, newPosition);
        }
    };

    getValueWith() {
        const node = this.hiddenValue.current;
        const node2 = this.hiddenValue2.current;
        this.setState({
            valueWith: node ? node.clientWidth + 6 : 0,
            valueWidth2: node2 ? node2.clientWidth + 7 : 0
        });
    }

    restrictInput(value) {
        return value.replace(/\s/g, '').replace(/-/g, '');
    }

    getError(value) {
        const model = this.state.model,
            min = model.getMinSumEdge();
        return value < min;
    }

    getRange(value, min, max) {
        const range = Math.abs(((value - min) * 100) / (max - min));
        return range <= 99 ? range : 99;
    }

    blurChangeInput = e => {
        const model = this.state.model,
            {name, props} = e.target;
        let min = model.getMinSumEdge(),
            {value} = e.target;
        value = value.replace(/\s/g, '');
        if (name === 'term') {
            min = model.getTerms()[0];
        }
        if ((isFinite(+value) && +value === parseInt(value, 10)) || value === '') {
            if (value < min) {
                e.target.value = min;
                model.changeField(name || props.name, min);
                this.setState({model}, () => this.getValueWith());
            }
        }
    };

    handleManualInput = e => {
        const model = this.state.model,
            target = e.target,
            value = target.value,
            name = target.name,
            {min, max} = model.fields,
            regExp = /^\d+$/;

        if (value.length && !regExp.test(value)) {
            return false;
        }

        if (value > max) {
            model.changeField(name, max);
            this.setState({model});
        } else {
            this.handleChange(e);
        }
    };

    defineTimeUnit = () => {
        const model = this.state.model;

        if (model.getTimeUnit() === 'month') {
            return `CALCULATOR_${model.getTimeUnit().toUpperCase()}`;
        }

        if (this.props.type === 'salary') {
            return `CALCULATOR_${model.getTimeUnit().toUpperCase()}S`;
        }

        return model.getCurrentTerm() === 0
            ? `CALCULATOR_${model.getTimeUnit().toUpperCase()}`
            : `CALCULATOR_${model.getTimeUnit().toUpperCase()}S`;
    };

    static displayName = 'Credit.Views.Calculator';

    static contextTypes = {
        app: PropTypes.object
    };
}
